import { useMutation } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';
import { ENDPOINTS } from '../constants/endpoints';

export class RegistrationError extends Error {}

export class DuplicateEmailError extends RegistrationError {
  static readonly CODE = 'DUPLICATE_EMAIL';

  constructor() {
    super('This email is already registered.');
  }
}

export interface RegisterOrganisationPayload {
  companyName: string;
  industry?: string;
  website?: string;
  phone?: string;
  staffBand: string;
  name: string;
  surname: string;
  email: string;
  password: string;
}

async function registerOrganisation(payload: RegisterOrganisationPayload) {
  const response = await apiFetch(ENDPOINTS.REGISTER_ORGANISATION, {
    method: 'POST',
    body: JSON.stringify(payload),
    isPublic: true,
  });

  if (response.ok) return;

  const body = await response.json().catch(() => ({}));
  if (body.code === DuplicateEmailError.CODE) {
    throw new DuplicateEmailError();
  }
  throw new RegistrationError(body.message ?? 'Registration failed');
}

export const useRegisterOrganisation = () => {
  return useMutation({ mutationFn: registerOrganisation });
};
